import { Component, OnInit, ViewChild } from '@angular/core';
import * as $ from 'jquery';
import 'datatables.net'
import { NewSurveyModalComponent } from "app/admin/new-survey-modal/new-survey-modal.component";
import { GridOptions } from "ag-grid/main";
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { Globals } from '../../globals';
import { AdminService } from 'app/services/admin/AdminService';

@Component({
    selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements OnInit {
    @ViewChild('newsurvey', {static: true}) public newSurveyModal: NewSurveyModalComponent;
    questions: string[] = [];
    type: number = 3;
    showPage: boolean = false;

    questionsHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;

    rowSelection: string;

    canEdit: boolean = false;
    canDelete: boolean = false;

    currentRowIndex: number;

    constructor
    (
        private _AdminService: AdminService,
        private toastr: ToastrService,
        private _Globals: Globals
    )
    {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
    }

  ngOnInit() {
      this.gridOptions = <GridOptions>{};
      this.gridOptions.rowHeight = 45;
      this.gridOptions.headerHeight = 40;

      this.questionsHeaders = this.createHeaders();

      this.getAllQuestions();
    }

  onResize(event: any) {
      //console.log("Width: " , event.currentTarget.innerWidth);
      //console.log("Height: " , event.currentTarget.innerHeight);
      setTimeout(() => {
          this.sizeToFit(this.gridApi);
          console.log('onResize');
      }, 0);
  }

  gridSize(count: number) {
      this.count = count;
      console.log('count', this.count);
      this.height = (this.count + 1) * 43;
  }

    sizeToFit(gridApi) {
        console.log('sizeToFit');
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

  onGridReady(params) {
      this.gridApi = params.api;
      this._Globals.gridApis.push(this.gridApi);
      console.log('GLOBALS');
      //this.sizeToFit(this.gridApi);
      setTimeout(() => {
          $(".ag-floating-filter-input").attr("placeholder", "Filter");
      }, 100);
  }

  getAllQuestions() {
//<<<<<<< HEAD
//      this.getQuestions.getQuestions(this.type).subscribe((data: any) => {
//          console.log('response_GetQuestions', data);
//          if (this._Globals.validationToken(data.result.Result)) {
//              let _data = JSON.parse(data.result.Data);
//              console.log('_data', _data);

//              this.questions = _data;
//              this.showPage = true;
//          }

//      });
//  }
      //=======
      this._AdminService.getQuestions(this.type).subscribe((data: any) => {
            console.log('response_getQuestions', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);

                this.questions = _data;
                this.showPage = true;
            } 
        });
    }

  openModal(action, index?, text?: string) {
      console.log("Action: ", action);
      this.newSurveyModal.show(text, this, action, index, true);
  }

  createHeaders() {
      let columnDefs = new Array();

     // let actionsHeader = {
     //   headerName: 'Actions',
     //   field: '',
     //   minWidth: 85,
     //   width: 85,
     //   suppressSizeToFit: true,
     //   suppressSorting: true,
     //   suppressMenu: true,
     //   cellRenderer: function (params) {
     //       let content = '';

     //       content += '<i id="editAction" class="material-icons custom-icons">edit</i>';

     //       content += '<i id="deleteAction" class="material-icons custom-icons">delete</i>';

     //       //content += '<i id="bulkUpload" class="material-icons custom-icons">file_upload</i>';

     //       return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

     //   }
     //};
     //columnDefs.push(actionsHeader);

      let nameHeader = {
          headerName: 'Text',
          field: 'Text',
          sort: 'asc',
          minWidth: 200,
          width: 200,
           headerCheckboxSelection: true,
           headerCheckboxSelectionFilteredOnly: true,
           checkboxSelection: true,
          suppressSizeToFit: false,
          cellRenderer: function (params) {
              //return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
              return params.value ;
          }
      };
      columnDefs.push(nameHeader);

      return columnDefs;
  }

  public onRowClicked(e) {
      console.log(e);
      if (e.event.target !== undefined) {
          let data = e.data;
          this.edit(data['Id'], data['Text']);

          //switch (e.event.target.id) {
          //    case "editAction":
          //        {
          //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
          //            this.edit(data['Id'], data['Text']);
          //            break;
          //        }

          //    case "deleteAction":
          //        {
          //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
          //            this.delete(data['Id'],);
          //            break;
          //        }
          //}
      }
    }

    deselectAllCheckBox() {
        this.canEdit = false;
        this.canDelete = false;
        this.gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }


    onRowSelected(event) {
        console.log("onRowSelected", event);
        this.currentRowIndex = event.rowIndex;
        console.log('currentRowIndex', this.currentRowIndex);
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canEdit = true;
        } else {
            this.canEdit = false;
        }

        if (rowCount == 1) {
            this.canDelete = true;
        } else {
            this.canDelete = false;
        }
    }

    editSelected() {
        if (this.canEdit) {
            let selected = this.getSelectedRows();
            let id = selected[0].Id;
            let text = selected[0].Text;
            console.log("SELECTED ID", id);

            this.openModal('edit', id, text);
        }
    }

    deleteSelected() {
        if (this.canDelete) {
            let selected = this.getSelectedRows();
            let id = selected[0].Id;
            console.log("SELECTED ID", id);

            this.delete(id);
        }
    }

    getSelectedRows(): any {
        console.log("SELECTED", this.gridApi.getSelectedRows());
        return this.gridApi.getSelectedRows();
    }

  edit(id: number, text: string) {
      console.log('edit');
      this.openModal('edit', id, text);
  }

  delete(id:number) {
      console.log('delete');
      swal({
          title: 'Confirm Delete',
          text: "Are you sure you want to delete this question?",
          showCancelButton: true,
          focusConfirm: false,
          allowEnterKey: false,
          cancelButtonColor: '#888',
          confirmButtonColor: '#3472F7',
          confirmButtonText: 'Yes'
      }).then((result: any) => {
          if (result.value) {
              this._AdminService.DeleteQuestion(id).subscribe(data => {
                  console.log(data);
                  if (data.result.Result == 1) {
                      this.getAllQuestions();
                      this.toastr.success('Deleted successfully.', 'ELI');
                  } else {
                      this.toastr.error('An error has ocurred while trying to delete the section question.', 'ELI');
                  }

              });
          }
      });
  }

}
